define(['moduler'], function (Moduler) {
    'use strict';
    
    return Moduler.create({
        defaults: {
            columnSelector: '.Grid-cell',
            itemSelector: '.List-itemContent',
            minWidthActive: 903,
            columns: null
        },
        
        init: function () {
            var self = this;

            self.columns = self.el.querySelectorAll(self.options.columnSelector);
            self.items = self.el.querySelectorAll(self.options.itemSelector);
            self.itemsMap = Array.from(self.columns).map(c => c.querySelectorAll(self.options.itemSelector));

            var upd = function () { self.updateItemHeights(); };
            window.addEventListener('resize', upd);
            (window.requestAnimationFrame && requestAnimationFrame(upd)) || setTimeout(upd, 16);
        },

        updateItemHeights:  function() {
            var self = this;
            var columnsCount = self.columns.length;
            
            self.items.forEach(itm => itm.style.height = '');

            if (document.body.clientWidth < self.options.minWidthActive) {
                return;
            } 

            if (!(typeof self.itemsMap === 'object') || self.itemsMap.length == 0) {
                return false;
            }

            for (var i = 0; i < self.itemsMap[0].length; i++) {
                var height = 0;
                var items = [];

                for (var u = 0; u < columnsCount; u++) {
                    var item = self.itemsMap[u][i];
                    var itemHeight = item.outerHeight;

                    if (itemHeight > height) {
                        height = itemHeight;
                    }

                    items.push(item);

                    if (self.options.columns && (u + 1) % self.options.columns === 0 && u > 0) {
                        self.setHeight(items, height);

                        height = 0;
                        items = [];
                    }
                }

                self.setHeight(items, height);
            }
        },

        setHeight: function(items, height) {
            items.forEach(item => {
                item.style.height = height;
            });
        }
    });
});